module.exports = __webpack_public_path__ + "img/liked.6ae07310.svg";